import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'
const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}zwiz-gpf-buddy`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const gpfBuddyApi = {
  getCompanyMasterData: (request) => {
    const { config } = request
    return instance().get('/cms/intents/company-info', {
      params: config
    })
  }
}
export default gpfBuddyApi



// WEBPACK FOOTER //
// ./src/api/gpf-buddy.js